import { render, staticRenderFns } from "./ChannelLogin.vue?vue&type=template&id=6e2f7b68&scoped=true&"
import script from "./ChannelLogin.vue?vue&type=script&lang=js&"
export * from "./ChannelLogin.vue?vue&type=script&lang=js&"
import style0 from "./ChannelLogin.vue?vue&type=style&index=0&id=6e2f7b68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2f7b68",
  null
  
)

export default component.exports